const actions = {
  SET_IS_CONFIRM_MODAL_SAVE_DRAFT_OPEN: "auth/SET_IS_CONFIRM_MODAL_SAVE_DRAFT_OPEN",
  SET_IS_CANCEL_MODAL_OPEN: "auth/SET_IS_CANCEL_MODAL_OPEN",
  SET_WELCOME_BANNER_DISMISSED: "common/SET_WELCOME_BANNER_DISMISSED",
  SET_CURRENCY_LOCALE: "common/SET_CURRENCY_LOCALE",

  setIsConfirmModalSaveDraftOpen: (value) => (dispatch) =>
    dispatch({
      type: actions.SET_IS_CONFIRM_MODAL_SAVE_DRAFT_OPEN,
      isConfirmModalSaveDraftOpen: value,
    }),
  setIsCancelModalOpen: (value) => (dispatch) =>
    dispatch({
      type: actions.SET_IS_CANCEL_MODAL_OPEN,
      isCancelModalOpen: value,
    }),
  setWelcomeBannerDismissed: (value) => (dispatch) =>
    dispatch({
      type: actions.SET_WELCOME_BANNER_DISMISSED,
      isWelcomeBannerDismissed: value,
    }),
  setCurrencyLocale: (locale) => (dispatch) =>
    dispatch({
      type: actions.SET_CURRENCY_LOCALE,
      currencyLocale: locale,
    })
};

export default actions;
